import React, { useState, useEffect } from "react";
import { Card, Switch, Avatar, Typography} from "@ann/web-components";
import Icon from "../../../../../../../elements/icon/Icon";
import {
  StatusAndMetricsContainer,
  Section,
  SectionTitle,
  CardInfo,
  Title,
  Value,
  LastUpdateRow,
} from "./StatusAndMetrics.styled";

const StatusAndMetrics = ({ 
  formData, 
  onActiveChange,
  triggerData = null
}) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    setIsActive(formData.active || false);
  }, [formData.active]);

  const handleSwitchChange = event => {
    const newValue = event.target.checked;
    setIsActive(newValue);
    onActiveChange(newValue);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    
    const dateFormat = date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric', 
      year: 'numeric'
    });
    
    const timeFormat = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
    
    return `${dateFormat} · ${timeFormat}`;
  };



  return (
    <StatusAndMetricsContainer>
      <Section>
        <SectionTitle>Status And Metrics</SectionTitle>
        <Card> 
          <CardInfo disabled={true}>
            <Title>State</Title>
            <Value>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <Switch
                  id="activeSwitch"
                  checked={isActive}
                  onChange={handleSwitchChange}
                  disabled={true}
                />
                <Typography category="body" size="medium" weight="regular">
                  {isActive ? "Active" : "Inactive"}
                </Typography>
              </div>
            </Value>

            <Title>Executions</Title>
            <Value>
              <Icon
                name="bolt"
                width="20px"
                height="20px"
                className="dark-icon"
              />
              {triggerData?.enrolled
                ? triggerData.enrolled.split(", ").length
                : 0}
            </Value>
          </CardInfo>
        </Card>
      </Section>

      <Section>
        <SectionTitle>Created By</SectionTitle>
        <Card>
          <CardInfo disabled={true}>
            <Title>User</Title>
            <Value>
              {triggerData?.photo_url ? (
                <Avatar name={triggerData?.createdBy || "Template"} />
              ) : (
                <Icon
                  name="carbonUserAvatarFilled"
                  width="32px"
                  height="32px"
                />
              )}
              <span>{triggerData?.createdBy || "User"}</span>
            </Value>
            <Title>Last Update</Title>
            <Value>
              <LastUpdateRow>
                <Icon name="iconUpdate" width="20px" height="20px" />
                {formatDate(triggerData?.lastUpdated)}
              </LastUpdateRow>
            </Value>
          </CardInfo>
        </Card>
      </Section>
    </StatusAndMetricsContainer>
  );
};

export default StatusAndMetrics;
